/** The backend setting this whole tool exists to produce. */
export const SETTING_NAME = "Institution.custom_i18n_overrides";

export const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
